import { render, staticRenderFns } from "./cookiebar.vue?vue&type=template&id=4ba415e1&"
import script from "./cookiebar.vue?vue&type=script&lang=js&"
export * from "./cookiebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports